import {FC} from 'react'

type Props = {
  title?: string,
}

const KTableLoading: FC<Props> = ({title}) => {
  const styles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: '800',
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
  }

  return (
    <div
      style={{
        background: 'rgba(255, 255, 255, 0.8)',
        zIndex: 99999,
        position: 'absolute',
        textAlign: 'center',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{...styles}}>
        <div>
          <div className='pb-2 text-dark'>{title}</div>
          <div>
            <div className='spinner-grow spinner-grow-sm text-info  me-2' role='status'></div>
            <div className='spinner-grow spinner-grow-sm text-info  me-2' role='status'></div>
            <div className='spinner-grow spinner-grow-sm text-info  me-2' role='status'></div>
            <div className='spinner-grow spinner-grow-sm text-info ' role='status'></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {KTableLoading}
